<template>
  <g class="ChartLegend" :transform="`translate(${offsetXVal}, ${offsetYVal})`">
    <rect
      class="ChartLegend-background"
      v-if="background"
      :fill="background"
      :width="totalWidth"
      :height="totalHeight"
      :stroke="borderColor"
      :stroke-width="borderWidth"
      :transform="`translate(${borderWidth / 2}, ${borderWidth / 2})`"
    />
    <g
      v-for="(item, key) in legend"
      class="ChartLegend-item"
      :key="key"
      :transform="`translate(${boxPadding}, ${key * itemHeight + boxPadding})`"
      :class="{
        'is-filtered': item.isActive,
        'is-filterable': item.isFilterable,
      }"
      :style="{ background }"
      @click.prevent="onClick(item)"
    >
      <rect
        class="ChartLegend-swatch"
        x="0"
        y="0"
        width="15"
        height="15"
        :fill="item.color"
      />
      <text
        class="ChartLegend-text"
        x="25"
        y="0"
        dominant-baseline="hanging"
        :width="boxWidth"
      >
        {{ item.label }}
      </text>
    </g>
  </g>
</template>

<script>
import { find } from 'lodash';

import Layer from './layer.vue';

export default {
  extends: Layer,
  name: 'DatalasLegend',
  props: {
    offsetX: {
      type: Number,
      default: 0,
    },
    offsetY: {
      type: Number,
      default: 0,
    },
    background: {
      type: String,
      default: '#ffffff',
    },
    boxWidth: {
      type: Number,
      default: 200,
    },
    boxHeight: {
      type: Number,
      default: null,
    },
    boxPadding: {
      type: Number,
      default: 20,
    },
    itemSpacing: {
      type: Number,
      default: 2,
    },
    borderWidth: {
      type: Number,
      default: 1,
    },
    borderColor: {
      type: String,
      default: '#000000',
    },
    dimensions: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    lineHeight: 15,
  }),
  computed: {
    itemHeight() {
      return this.lineHeight + this.itemSpacing;
    },
    colors() {
      const { transform } = find(this.dimensions, { dimension: 'colors' });
      return this.transforms[transform].transformer().range();
    },
    labels() {
      const { transform } = find(this.dimensions, { dimension: 'labels' });
      return this.transforms[transform].transformer().range();
    },
    legend() {
      return this.labels.map((label, i) => ({
        label,
        color: this.colors[i],
      }));
    },
    totalHeight() {
      return (
        (this.boxHeight ||
          this.itemHeight * this.legend.length - this.itemSpacing) +
        this.boxPadding * 2
      );
    },
    totalWidth() {
      return this.boxWidth + this.boxPadding * 2;
    },
    offsetXVal() {
      return (this.offsetX * (this.chartWidth - this.totalWidth)) / 100;
    },
    offsetYVal() {
      return (this.offsetY * (this.chartHeight - this.totalHeight)) / 100;
    },
  },
  methods: {
    onClick(item) {
      if (!item.isFilterable) return;
      // TODO
      const context = item.layer;
      if (item.isActive) {
        // Pass exact reference to filter in state when removing
        const filter = find(item.layer.filters, item.filter);
        this.$store.commit('REMOVE_CHART_FILTER', { context, filter });
      } else {
        const { filter } = item;
        this.$store.commit('SET_CHART_FILTER', { context, filter });
      }
    },
  },
};
</script>

<style lang="scss">
.ChartLegend {
  &-item {
    cursor: default;
    font-size: 13px;

    &.is-filterable {
      cursor: pointer;
    }

    &.is-filtered {
      opacity: 0.4;
    }
  }
}
</style>
